import React from 'react';
import PropTypes from 'prop-types';
import {DataTable} from '@learningblocks/storybook-components';
import {QuestionWrapper} from '../Components/QuestionWrapper';
import {MainTitle} from '../Components/MainTitle';
import {Question} from '../Components/Question';
import {Footer} from '../Components/Footer';
import {TotalAttempts} from '../Components/TotalAttempts';
import {SubmitButton} from '../Components/SubmitButton';

import {cloneDeep} from 'lodash';
import { Feedback } from '@learningblocks/exp-components/lib/QuestionTable/Feedback';

import './style.scss';
export function QuestionTable(props) {
  const onSubmit = () => props.submitAnswer(props.id, props.type);
  const isCorrect = () => {
    let correct = true;
    cloneDeep(props.data).forEach(row => {
      row.forEach(item => {
        if(item.type === "INPUT"){
          if (typeof item.answer === "string") {
            if(item.answer.toLowerCase() !== item.value.toLowerCase()){
              correct = false;
            }
          }
          if (typeof item.answer === "number") {
            if(correct = item.answer !== item.value) {
              correct = false;
            }
          }
          if (Array.isArray(item.answer)) {
            if(item.value < item.answer[0] && item.value > item.answer[1]){
              correct = false;
            }
          }
        }
      })
    })
    return correct;
  }
  return (
    <QuestionWrapper className='questionTable'>
      <MainTitle className='questionTable__mainTitle' />
      <Question text={props.question} className='questionTable__question' />
      <Question text={props.text} className='questionTable__question' />
      <DataTable
        className={'questionTable__tableWrapper'}
        indices={props.indices}
        data={props.data}
        onCellChange={props.onCellChange}
      />
      <Footer className='questionTable__footer'>
        <TotalAttempts
          totalAttempts={props.totalAttempts}
          className='questionTable__footer__totalAttempts'
        />
        <SubmitButton disabled={props.submitDisabled} onSubmit={onSubmit} />
      </Footer>
      {
        props.feedbackType ? 
        <Feedback
            type={props.feedbackType}
            onClose={props.closeFeedback}
          />
          : ''
      }
    </QuestionWrapper>
  );
}

QuestionTable.propTypes = {
  /**
   * Question for the component
   */
  question: PropTypes.string,
  /**
   * Number of [rows, columns] in the table
   */
  indices: PropTypes.arrayOf(PropTypes.number),
  /**
   * Data to be rendered in the table
   */
  data: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        /**
         * The type of the cell
         */
        type: PropTypes.oneOf(['TITLE', 'FIXED', 'INPUT', 'DROPDOWN']),
        /**
         * Text to render in cell [ TITLE, FIXED]
         */
        text: PropTypes.text,
        /**
         * Type of the input [ INPUT ]
         */
        inputType: PropTypes.oneOf(['number', 'text']),
        /**
         * placeholder of for cell [ DROPDOWN, INPUT]
         */
        placeholder: PropTypes.string,
        /**
         * options to display on dropdown [DROPDOWN]
         */
        options: PropTypes.array,
        /**
         * Boolean to disable the cell
         */
        disabled: PropTypes.bool,
      })
    )
  ),
  /**
   * Function to invoke when the data in a cell changes
   */
  onCellChange: PropTypes.func,
  /**
   * Boolean to set if quesiton is complete
   */
  complete: PropTypes.bool,
  /**
   * UniqueId for the question component
   */
  id: PropTypes.number,
  /**
   * Total number of  attempts to solve question
   */
  totalAttempts: PropTypes.number,
  /**
   * Function to invoke on submit button click
   */
  submitAnswer: PropTypes.func,
  /**
   * Boolean to set submit button enabled/disabled
   */
  submitDisabled: PropTypes.bool,
};
